import { ROLE } from '../../staticRoleManagement/types'
import { PMSRequestedMethod } from '../../types/cart'

/**
 * Only an admin chooses how a booking is sent to the hotel's PMS. adotel refuses any method
 * other than Auto from everyone else ("You are not allowed to override the PMS request
 * method."), so the choice is hidden from them and Auto is always sent.
 */
export const canChoosePmsRequestedMethod = (role: ROLE | undefined): boolean =>
  role === ROLE.ADMIN

/** The method to send: the chosen one for an admin, Auto for everyone else. */
export const pmsRequestedMethodFor = (
  role: ROLE | undefined,
  chosen: PMSRequestedMethod
): PMSRequestedMethod => (canChoosePmsRequestedMethod(role) ? chosen : 'Auto')
